module.exports = __webpack_public_path__ + "img/ecfbda17-6394-4515-90d5-984b27a2b44b.a4c414b5.png";